import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const RecurringamortEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		policyno: yup.string().required().label($t('policyno')),
		period: yup.number().required().label($t('period')),
		paydate: yup.string().required().label($t('paydate')),
		amount: yup.string().required().label($t('amount')),
		paid: yup.string().required().label($t('paid')),
		install_type: yup.string().required().label($t('installType')),
		trxnid: yup.string().nullable().label($t('trxnid')),
		merchanttrxnrefid: yup.string().nullable().label($t('merchanttrxnrefid')),
		req_status: yup.string().nullable().label($t('reqStatus')),
		payment_transaction_identifier: yup.string().nullable().label($t('paymentTransactionIdentifier'))
	});
	// form default values
	const formDefaultValues = {
		policyno: '', 
		period: '', 
		paydate: new Date(), 
		amount: '', 
		paid: "(N'NO", 
		install_type: '', 
		trxnid: '', 
		merchanttrxnrefid: '', 
		req_status: '', 
		payment_transaction_identifier: '', 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/recurringamort`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="RecurringamortEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('editRecurringamort')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('policyno')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/policyno_option_list_2"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="policyno"     optionLabel="label" optionValue="value" value={formik.values.policyno} onChange={formik.handleChange} options={response} label={$t('policyno')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.policyno)}   />
                                                    <ErrorMessage name="policyno" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('period')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="period"  onChange={formik.handleChange}  value={formik.values.period}   label={$t('period')} type="number" placeholder={$t('enterPeriod')}  min={0}  step="any"    className={inputClassName(formik?.errors?.period)} />
                                                <ErrorMessage name="period" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('paydate')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="paydate" value={formik.values.paydate} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.paydate)}        />
                                                <ErrorMessage name="paydate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('amount')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="amount"  onChange={formik.handleChange}  value={formik.values.amount}   label={$t('amount')} type="text" placeholder={$t('enterAmount')}        className={inputClassName(formik?.errors?.amount)} />
                                                <ErrorMessage name="amount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('paid')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="paid"  onChange={formik.handleChange}  value={formik.values.paid}   label={$t('paid')} type="text" placeholder={$t('enterPaid')}        className={inputClassName(formik?.errors?.paid)} />
                                                <ErrorMessage name="paid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('installType')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="install_type"  onChange={formik.handleChange}  value={formik.values.install_type}   label={$t('installType')} type="text" placeholder={$t('enterInstallType')}        className={inputClassName(formik?.errors?.install_type)} />
                                                <ErrorMessage name="install_type" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('trxnid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="trxnid"  onChange={formik.handleChange}  value={formik.values.trxnid}   label={$t('trxnid')} type="text" placeholder={$t('enterTrxnid')}        className={inputClassName(formik?.errors?.trxnid)} />
                                                <ErrorMessage name="trxnid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('merchanttrxnrefid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="merchanttrxnrefid"  onChange={formik.handleChange}  value={formik.values.merchanttrxnrefid}   label={$t('merchanttrxnrefid')} type="text" placeholder={$t('enterMerchanttrxnrefid')}        className={inputClassName(formik?.errors?.merchanttrxnrefid)} />
                                                <ErrorMessage name="merchanttrxnrefid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('reqStatus')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="req_status"  onChange={formik.handleChange}  value={formik.values.req_status}   label={$t('reqStatus')} type="text" placeholder={$t('enterReqStatus')}        className={inputClassName(formik?.errors?.req_status)} />
                                                <ErrorMessage name="req_status" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('paymentTransactionIdentifier')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="payment_transaction_identifier"  onChange={formik.handleChange}  value={formik.values.payment_transaction_identifier}   label={$t('paymentTransactionIdentifier')} type="text" placeholder={$t('enterPaymentTransactionIdentifier')}        className={inputClassName(formik?.errors?.payment_transaction_identifier)} />
                                                <ErrorMessage name="payment_transaction_identifier" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label={$t('update')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
RecurringamortEditPage.defaultProps = {
	primaryKey: 'collectionid',
	pageName: 'recurringamort',
	apiPath: 'recurringamort/edit',
	routeName: 'recurringamortedit',
	submitButtonLabel: $t('update'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('updateRecord'),
	msgAfterSave: $t('recordUpdatedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default RecurringamortEditPage;
